"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var react_syntax_highlighter_1 = require("react-syntax-highlighter");
var styles_1 = require("react-syntax-highlighter/dist/styles");
var components_1 = require("components");
var ExampleHeader_1 = require("./ExampleHeader");
var ExampleBody_1 = require("./ExampleBody");
var componentStyle = {
    base: {
        marginTop: 20,
        borderRadius: 3,
    },
};
var Example = (function (_super) {
    __extends(Example, _super);
    function Example(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showCode: false,
        };
        return _this;
    }
    Example.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, code = _a.code, children = _a.children;
        var showCode = this.state.showCode;
        return (React.createElement(components_1.Paper, { style: componentStyle.base },
            React.createElement(ExampleHeader_1.ExampleHeader, { title: title, onClickShowCode: this.toggleCodeView.bind(this) }),
            showCode && (React.createElement(react_syntax_highlighter_1.default, { language: "js", style: styles_1.grayscale }, code)),
            React.createElement(ExampleBody_1.ExampleBody, { description: description }, children)));
    };
    Example.prototype.toggleCodeView = function () {
        this.setState({ showCode: !this.state.showCode });
    };
    Example = __decorate([
        Radium,
        __metadata("design:paramtypes", [Object])
    ], Example);
    return Example;
}(react_1.PureComponent));
exports.Example = Example;



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Example/Example.tsx
// module id = 326
// module chunks = 0